import Filters from 'filters';
import List from 'list';
import Request from 'request';
import Map from 'map';
import Graph from 'graph';
import MapIndexControls from 'map_index_controls';

document.addEventListener("DOMContentLoaded", () => {
  $("body").tooltip({ selector: '[data-toggle=tooltip]' });

  $(".multiple-dropdown").select2({
    multiple: true
  });

  $( window ).resize(function() {
    Filters.resizeRecordContainer();
  });

  $('.js-chart-duration-toggle').click(function(event) {
    let duration = $(event.currentTarget).data('key');
    buildGraph(duration)
    $('.js-chart-duration-toggle').removeClass('active')
    $(event.currentTarget).addClass('active')
  })

  if ($('#js-map-index').length) {
    Filters.parseFilters();
    let view = "map";
    window.spinner = "";
    const map = new Map();
    let mapReady = map.setupMap();

    var buildGraph = function(duration) {
      let requests = [
        {
          endpoint: "/metrics/incidents.json",
          group: "record_count",
          attack_characteristics: "true",
          series_name: "# of attacks",
          duration: duration
        },
        {
          endpoint: "/metrics/incidents.json",
          group: "civilian_fatalities",
          attack_characteristics: "true",
          series_name: "# of civilians killed",
          duration: duration
        },
        {
          endpoint: "/metrics/incidents.json",
          group: "civilian_abductions",
          attack_characteristics: "true",
          series_name: "# of civilians abducted",
          duration: duration
        }
      ]
      var options = {
        graph_id: "metrics",
        graph_type: "line",
        graph_colors: ["#2f7ed8",'#0d233a', '#525252', '#910000'],
        graph_title: "Metrics"
      };
      let graph = new Graph();
      graph.build(requests, options)
    };

    var buildMap = function() {
      let request = Request.buildRequest({
        endpoint: "/" + document.getElementById('js-record-type').dataset.recordType + ".json",
        request_type: "max_records"
      })
      fetch(request)
        .then((response) => {
          return response.json()
        })
        .then((data) => {
          mapReady.then(() => { map.build(data); });
        })
    };

    window.buildList = function(page) {
      let request = Request.buildRequest({
        endpoint: "/" + document.getElementById('js-record-type').dataset.recordType + ".json",
        stream_type: "violence",
        type: $('#type').val(),
        request_type: "paginated",
        page: page
      })
      var listOptions = {
        template_id: "#" + document.getElementById('js-record-type').dataset.recordType + "-template",
        target_id: "#record-list"
      };
      var metricsOptions = {
        template_id: "#stats-template",
        target_id: ".js-stats-template"
      };
      const list = new List();
      fetch(request)
        .then((response) => response.json())
        .then((data) => {
          list.build(data, listOptions);
          list.build(data, metricsOptions);
        })
    };

    var load = function() {
      if (spinner) { spinner.stop() };
      // startSpinner();
      buildMap();
      window.buildList(1);
      buildGraph("month");
      Filters.loadFiltersByRecordType();
      Filters.watchGroupedCheckboxes();

      $('.js-more-filters').find('.js-more-filter-option').each(function(index, element) {
        let recordType = document.getElementById('js-record-type').dataset.recordType;
        if($(element).data('filterRecordTypes').includes(recordType)) {
          $(element).closest('.dropdown-checkbox-row').show();
        } else {
          $(element).closest('.dropdown-checkbox-row').hide();
        }
      })
    };

    let mapIndexControls = new MapIndexControls();
    mapIndexControls.addListeners();
    
    Filters.watchFilters(load);
    load();
  };
});
